/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography,Badge} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import {DIRECCIONLOCALES, NEGRITA, REDES, SECCIONES} from "../../Constantes";
import {ShoppingCart, WhatsApp} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {irUrl} from "../../Utilidades/irUrl";
import {useMenuPop} from "../../Modulo_Menu_Pop/Hooks/useMenuPop";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useCarritoFlotante} from "../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";


const BarraPc = () => {
    const {ir} = useIrRuta()
    const navigate = useNavigate();
    const {MenuPop, abrirMenu} = useMenuPop()
    const {Carrito, abrir} = useCarritoFlotante()
    const {productos} = useProductosCarrito()

    const clickMenu = (it) => {

        iniciarChatWass({mensaje: 'Hola Quesuditas ' + it.nombre, numero: it.celular})

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 3}}
            >

                <Carrito/>

                <MenuPop opciones={[DIRECCIONLOCALES[0]]} click={clickMenu}/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={220} height={'auto'} alt={"logo"} onClick={() => navigate('/Home')}
                                 style={{cursor: 'pointer'}}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{px: 6}}
                            >


                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        onClick={() => ir(item)}
                                        sx={{
                                            fontFamily: NEGRITA,
                                            color: '#fff',
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            transition: "all .2s ease-in-out",
                                            '&:hover': {
                                                borderColor: '#ffffff',
                                            }
                                        }}>{item.toUpperCase()}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                            >

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[0].url)}>
                                    <img src={REDES[0].img} width={34} height={'auto'}/>
                                </IconButton>

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[1].url)}>
                                    <img src={REDES[1].img} width={34} height={'auto'}/>
                                </IconButton>

                                <IconButton sx={{p: 0}} onClick={() => irUrl(REDES[2].url)}>
                                    <img src={REDES[2].img} width={34} height={'auto'}/>
                                </IconButton>

                                {/*<Button
                                    onClick={(e) => abrirMenu(e)}
                                    sx={{color: theme.palette.primary.main}}
                                    startIcon={<WhatsApp/>}
                                    color="secondary"

                                >
                                    Contactar
                                </Button>*/}

                                <IconButton sx={{p: 1, backgroundColor: theme.palette.primary.main}}
                                            onClick={(e) => abrirMenu(e)}>
                                    <WhatsApp sx={{fill: '#fff'}}/>
                                </IconButton>

                                <IconButton sx={{p: 1, backgroundColor: theme.palette.primary.main}}
                                            onClick={() => abrir()}>
                                    <Badge badgeContent={productos.length} color="secondary">
                                        <ShoppingCart sx={{fill: '#fff'}}/>
                                    </Badge>
                                </IconButton>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc



